(function () {
  'use strict';

  function initVideoGrid(root) {
    var grid = root.querySelector('[data-video-grid]');
    if (!grid || grid.dataset.vgInit === 'true') return;
    grid.dataset.vgInit = 'true';

    var tiles = Array.prototype.slice.call(grid.querySelectorAll('[data-video-tile]'));
    if (!tiles.length) return;

    var lightbox = root.querySelector('[data-video-lightbox]') || document.querySelector('[data-video-lightbox]');
    var stage = lightbox ? lightbox.querySelector('[data-video-lightbox-stage]') : null;
    var closeBtn = lightbox ? lightbox.querySelector('[data-video-lightbox-close]') : null;

    var activeLightboxVideo = null;
    var activeLightboxHome = null;
    var lastFocusedTile = null;

    function columnsForWidth(width) {
      if (width >= 990) return 3;
      if (width >= 750) return 2;
      return 1;
    }

    function layoutColumns() {
      var count = columnsForWidth(window.innerWidth);
      if (grid.dataset.vgColumns === String(count)) return;
      grid.dataset.vgColumns = String(count);

      var cols = [];
      grid.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var col = document.createElement('div');
        col.className = 'video-grid__col';
        grid.appendChild(col);
        cols.push(col);
      }

      tiles.forEach(function (tile) {
        var shortest = cols[0];
        cols.forEach(function (col) {
          if (col.offsetHeight < shortest.offsetHeight) shortest = col;
        });
        shortest.appendChild(tile);
      });

      grid.setAttribute('data-columns-ready', 'true');
    }

    function playTile(tile) {
      var video = tile.querySelector('[data-video]');
      if (!video) return;
      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    }

    function resetTile(tile) {
      var video = tile.querySelector('[data-video]');
      if (!video) return;
      video.pause();
      try {
        video.currentTime = 0;
      } catch (e) {}
    }

    function openLightbox(tile) {
      var video = tile.querySelector('[data-video]');
      if (!video || !lightbox || !stage) return;

      resetTile(tile);

      activeLightboxHome = { parent: video.parentNode, next: video.nextSibling };
      activeLightboxVideo = video;
      lastFocusedTile = tile;

      stage.appendChild(video);
      video.muted = false;
      video.loop = false;
      video.controls = true;
      video.setAttribute('playsinline', '');
      try {
        video.currentTime = 0;
      } catch (e) {}
      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});

      lightbox.hidden = false;
      document.addEventListener('keydown', onKeydown);
      if (closeBtn) closeBtn.focus();
    }

    function closeLightbox() {
      if (!activeLightboxVideo || !lightbox) return;

      var video = activeLightboxVideo;
      video.pause();
      video.muted = true;
      video.loop = true;
      video.controls = false;
      try {
        video.currentTime = 0;
      } catch (e) {}

      if (activeLightboxHome) {
        if (activeLightboxHome.next) {
          activeLightboxHome.parent.insertBefore(video, activeLightboxHome.next);
        } else {
          activeLightboxHome.parent.appendChild(video);
        }
      }

      lightbox.hidden = true;
      document.removeEventListener('keydown', onKeydown);
      if (lastFocusedTile) lastFocusedTile.focus();

      activeLightboxVideo = null;
      activeLightboxHome = null;
      lastFocusedTile = null;
    }

    function onKeydown(event) {
      if (event.key === 'Escape' || event.key === 'Esc') closeLightbox();
    }

    tiles.forEach(function (tile) {
      tile.addEventListener('mouseenter', function () {
        playTile(tile);
      });
      tile.addEventListener('mouseleave', function () {
        resetTile(tile);
      });
      // Touch: press and hold previews the clip muted, lifting the finger stops it.
      // A quick tap still falls through to the click handler and opens the lightbox.
      var holdTimer = null;
      var touchStartY = 0;
      var suppressClick = false;

      function endHold() {
        clearTimeout(holdTimer);
        holdTimer = null;
        if (tile.dataset.vgHolding === 'true') {
          delete tile.dataset.vgHolding;
          resetTile(tile);
        }
      }

      tile.addEventListener('touchstart', function (event) {
        touchStartY = event.touches[0].clientY;
        suppressClick = false;
        holdTimer = setTimeout(function () {
          tile.dataset.vgHolding = 'true';
          suppressClick = true;
          playTile(tile);
        }, 200);
      }, { passive: true });

      tile.addEventListener('touchmove', function (event) {
        if (Math.abs(event.touches[0].clientY - touchStartY) > 10) endHold();
      }, { passive: true });

      tile.addEventListener('touchend', endHold);
      tile.addEventListener('touchcancel', endHold);
      tile.addEventListener('contextmenu', function (event) {
        if (tile.dataset.vgHolding === 'true') event.preventDefault();
      });

      tile.addEventListener('click', function (event) {
        if (suppressClick) {
          suppressClick = false;
          event.preventDefault();
          return;
        }
        openLightbox(tile);
      });
      tile.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openLightbox(tile);
        }
      });
    });

    if (lightbox) {
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) closeLightbox();
      });
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', closeLightbox);
    }

    layoutColumns();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(layoutColumns, 150);
    });
  }

  function initAll() {
    document.querySelectorAll('.video-grid-section').forEach(function (root) {
      initVideoGrid(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.video-grid-section');
    if (root) initVideoGrid(root);
  });
})();
